module.exports = __webpack_public_path__ + "img/property_3_midtown.c7580810.jpg";